// extracted by mini-css-extract-plugin
module.exports = {"description":"style__description__TFMgI","report":"style__report__DOxgy"};